import React, { useState } from 'react';
import './Login.css';
import { authAPI } from '../api/auth';

// 腾讯云短信签名审核通过前暂时关闭；改为 true 即可恢复验证码登录/注册
const SMS_LOGIN_ENABLED = false;

function Login() {
  const [activeTab, setActiveTab] = useState(SMS_LOGIN_ENABLED ? 'sms' : 'password');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [nickname, setNickname] = useState('');
  const [isRegister, setIsRegister] = useState(false);
  const [message, setMessage] = useState('');

  const showMessage = (text) => {
    setMessage(text);
    window.setTimeout(() => setMessage(''), 2600);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isRegister) {
        if (activeTab === 'sms') {
          const response = await authAPI.registerByCode({ phone, verificationCode, nickname });
          console.log('验证码注册成功', response);
          localStorage.setItem('token', response.token);
          window.location.href = '/personal';
        } else {
          const response = await authAPI.register({ phone, password, nickname });
          console.log('注册成功', response);
          localStorage.setItem('token', response.token);
          window.location.href = '/personal';
        }
      } else {
        if (activeTab === 'sms') {
          const response = await authAPI.loginByCode({ phone, verificationCode });
          console.log('验证码登录成功', response);
          localStorage.setItem('token', response.token);
          if (response.isAdmin) {
            window.location.href = '/admin';
          } else {
            window.location.href = '/study';
          }
        } else {
          const response = await authAPI.login({ phone, password });
          console.log('密码登录成功', response);
          localStorage.setItem('token', response.token);
          if (response.isAdmin) {
            window.location.href = '/admin';
          } else {
            window.location.href = '/study';
          }
        }
      }
    } catch (error) {
      console.error('登录或注册失败', error);
      showMessage(error.response?.data?.message || '操作失败，请重试');
    }
  };

  const handleGetCode = async () => {
    try {
      if (!phone) {
        showMessage('请先写上手机号哦');
        return;
      }
      const scene = isRegister ? 'register' : 'login';
      const response = await authAPI.sendCode(phone, scene);
      console.log('获取验证码成功', response);
      showMessage('验证码已发送，请查看手机');
    } catch (error) {
      console.error('获取验证码失败', error);
      showMessage(error.response?.data?.message || '获取验证码失败，请重试');
    }
  };

  return (
    <div className="login-container">
      <div className="login-hero">
        <div className="hero-mascot">诗</div>
        <p className="hero-kicker">每日一首，出口成章</p>
        <h1>快乐学古诗</h1>
        <p className="hero-copy">跟着小书童听、读、背、闯关，收集元宝换礼物。</p>
      </div>
      <div className="login-card">
        <h2>{isRegister ? '注册账号' : '欢迎回来'}</h2>
        {message && <div className="login-message">{message}</div>}
        
        {SMS_LOGIN_ENABLED && (
          <div className="tab-container">
            <button
              className={`tab-btn ${activeTab === 'sms' ? 'active' : ''}`}
              onClick={() => setActiveTab('sms')}
            >
              {isRegister ? '验证码注册' : '验证码登录'}
            </button>
            <button
              className={`tab-btn ${activeTab === 'password' ? 'active' : ''}`}
              onClick={() => setActiveTab('password')}
            >
              {isRegister ? '密码注册' : '密码登录'}
            </button>
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>手机号</label>
            <input 
              type="tel" 
              value={phone} 
              onChange={(e) => setPhone(e.target.value)}
              required
            />
          </div>

          {SMS_LOGIN_ENABLED && activeTab === 'sms' ? (
            <div className="form-group">
              <label>验证码</label>
              <div className="code-input">
                <input 
                  type="text" 
                  value={verificationCode} 
                  onChange={(e) => setVerificationCode(e.target.value)}
                  required
                />
                <button 
                  type="button" 
                  className="code-btn"
                  onClick={handleGetCode}
                >
                  获取验证码
                </button>
              </div>
            </div>
          ) : (
            <div className="form-group">
              <label>密码</label>
              <input 
                type="password" 
                value={password} 
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
          )}

          {isRegister && (
            <div className="form-group">
              <label>昵称（可选）</label>
              <input 
                type="text" 
                value={nickname} 
                onChange={(e) => setNickname(e.target.value)}
              />
            </div>
          )}

          <button type="submit" className="login-btn">
            {isRegister ? '注册' : '登录'}
          </button>

          <div className="register-link">
            {isRegister ? (
              <span>已有账号？ <button type="button" className="link-button" onClick={() => setIsRegister(false)}>立即登录</button></span>
            ) : (
              <span>还没账号？ <button type="button" className="link-button" onClick={() => setIsRegister(true)}>立即注册</button></span>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;